import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const heroImagePath = encodeURI(`${process.env.PUBLIC_URL}/pictures/WhatsApp Image 2026-04-10 at 18.08.43.jpeg`);
  const heroStyle = {
    backgroundImage: `url("${heroImagePath}")`
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero" style={heroStyle}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>A Mission-Driven Vision for Thriving Communities</h1>
          <p>
            Working across Health, Education, Child Protection, and Sustainable Development
            to create lasting positive change
          </p>
          <div className="hero-buttons">
            <Link to="/about" className="btn btn-primary">Learn More</Link>
            <Link to="/get-involved" className="btn btn-secondary">Get Involved</Link>
          </div>
        </div>
      </section>

      {/* About Abstract 
      <section className="section about-abstract">
        <div className="container">
          <div className="section-header">
            <h2>About The Bluepoint Org</h2>
            <div className="section-line"></div>
          </div>
          <div className="about-content">
            <div className="about-text">
              <p className="lead">
                The Bluepoint Org is a mission-driven organisation working to build healthy, safe, and thriving communities.
                Our work focuses on <strong>Health, Education, Child Protection, and Sustainable Development</strong>, with
                the belief that every individual—especially every child—deserves the opportunity to live with dignity, safety, and hope.
              </p>
              <Link to="/about" className="read-more">Read More About Us →</Link>
            </div>
            <div className="about-image">
              <img src="/pictures/WhatsApp Image 2026-03-30 at 20.01.31.jpeg" alt="Community" />
            </div>
          </div>
        </div>
      </section>*/}

      {/* Focus Areas */}
      <section className="section focus-areas">
        <div className="container">
          <div className="section-header">
            <h2>Our Focus Areas</h2>
            <div className="section-line"></div>
          </div>
          <div className="focus-grid">
            <div className="focus-card">
              <div className="focus-icon">
                <img src="/pictures/WhatsApp Image 2026-04-10 at 18.08.43.jpeg" alt="Health" />
              </div>
              <h3>Health</h3>
              <p>
                Promoting physical and mental well-being through community programs, awareness initiatives,
                and psychosocial support to help people access care and build resilience.
              </p>
            </div>

            <div className="focus-card">
              <div className="focus-icon">
                <img src="/pictures/WhatsApp Image 2026-04-10 at 18.08.44.jpeg" alt="Education" />
              </div>
              <h3>Education</h3>
              <p>
                Empowering individuals through education initiatives focused on helping children and young people
                develop life skills, creativity, confidence, and critical thinking.
              </p>
            </div>

            <div className="focus-card">
              <div className="focus-icon">
                <img src="/pictures/WhatsApp Image 2026-04-10 at 18.08.45.jpeg" alt="Child Protection" />
              </div>
              <h3>Child Protection</h3>
              <p>
                Ensuring every child grows up in a safe and nurturing environment by preventing abuse, neglect,
                and exploitation through awareness and advocacy.
              </p>
            </div>

            <div className="focus-card">
              <div className="focus-icon">
                <img src="/pictures/WhatsApp Image 2026-04-10 at 18.08.46.jpeg" alt="Sustainable Development" />
              </div>
              <h3>Sustainable Development</h3>
              <p>
                Supporting initiatives that promote responsible resource use, community participation, and inclusive
                growth for long-term sustainable solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Activities Abstract */}
      <section className="section activities-abstract">
        <div className="container">
          <div className="section-header">
            <h2>Our Services</h2>
            <div className="section-line"></div>
            <p className="section-subtitle">
              Comprehensive programs and services designed to create measurable, sustainable impact
            </p>
          </div>

          <div className="services-flash-layout">
            <div className="services-flash-grid services-flash-top">
              <div className="service-flash-card">
                <h3>Bluepoint Personal Growth Lab</h3>
                <p className="service-flash-subheading">Touching Lives</p>
                <Link to="/program-management#personal-growth-lab" className="service-flash-link">Learn More →</Link>
              </div>

              <div className="service-flash-card">
                <h3>Bluepoint Change Makers</h3>
                <p className="service-flash-subheading">Training and Development Program for Young Professionals</p>
                <Link to="/program-management#change-makers" className="service-flash-link">Learn More →</Link>
              </div>

              <div className="service-flash-card">
                <h3>Bluepoint Catalysts</h3>
                <p className="service-flash-subheading">Human Resources and Organization Development Centre</p>
                <Link to="/program-management#catalysts" className="service-flash-link">Learn More →</Link>
              </div>
            </div>

            <div className="services-flash-grid services-flash-bottom">
              <div className="service-flash-card">
                <h3>Adolescent &amp;<br />Youth Training</h3>
                <Link to="/youth-training" className="service-flash-link">Learn More →</Link>
              </div>

              <div className="service-flash-card">
                <h3>HR &amp; Organization Development</h3>
                <Link to="/hr-development" className="service-flash-link">Learn More →</Link>
              </div>

              <div className="service-flash-card">
                <h3>Creative Communication</h3>
                <Link to="/communication" className="service-flash-link">Learn More →</Link>
              </div>

              <div className="service-flash-card">
                <h3>Research &amp; Consulting</h3>
                <Link to="/research" className="service-flash-link">Learn More →</Link>
              </div>
            </div>
          </div>

          {/* Flagship Projects */}
          <div className="flagship-projects">
            <div className="section-header" style={{ marginTop: '60px' }}>
              <h2>Our Flagship Projects</h2>
              <div className="section-line"></div>
            </div>

            <div className="flagship-grid">
              <div className="flagship-card">
                <h3>Kaval</h3>
                <p>
                  The Bluepoint Org is implementing Kaval projects in Trivandrum and Ernakulam districts, supported by the Department of 
                  Women and Child Development, Government of Kerala. A systematic and structured intervention program 
                  designed for children in conflict with law, Kaval provides comprehensive rehabilitation, counseling, 
                  and reintegration support to help young individuals rebuild their lives and become productive members 
                  of society. The project focuses on addressing behavioral issues, skill development, and creating 
                  pathways for positive transformation.
                </p>
              </div>

              <div className="flagship-card">
                <h3>Kaval Plus</h3>
                <p>
                  The Kaval Plus project provides holistic care and support for children in need of care and protection, 
                  and survivors of child sexual abuse. The Bluepoint Org is running Kaval Plus projects in Trivandrum and Ernakulam 
                  districts, offering trauma-informed counseling, legal support, medical assistance, and psychosocial 
                  rehabilitation. The program ensures a safe, nurturing environment where vulnerable children receive 
                  comprehensive care, protection, and the support they need to heal and thrive.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Blue Point */}
      <section className="section why-bluepoint">
        <div className="container">
          <div className="why-content">
            <div className="why-text">
              <h2>Why 'The Bluepoint Org'?</h2>
              <div className="section-line"></div>
              <p>
                Inspired by immense and ancient knowledge, The Bluepoint Org represents the essence of life
                sustained by nature's elements: air, water, fire, land, and the sky. Among these, the sky,
                symbolized by the color blue, represents unbounded space, vastness, and infinite potential—just
                like the human mind.
              </p>
              <p>
                Blue embodies <strong>trust, loyalty, wisdom, intelligence, sincerity, and peace</strong>. As the color of the
                spirit, blue has a calming effect, invoking tranquility and fostering balance and self-expression.
              </p>
              <p className="highlight">
                At The Bluepoint Org, we believe every individual possesses vast potential and inner depth.
                Our mission is to tap into these "blue points" of intellect and spirit, fostering growth and transformation.
              </p>
            </div>
            <div className="why-image">
              <img src="/pictures/WhatsApp Image 2026-03-30 at 20.01.35 (1).jpeg" alt="Bluepoint Vision" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Get Involved</h2>
            <p>
              Real change happens when people come together with a shared purpose. Join us in creating
              safer childhoods, stronger communities, and a more sustainable future.
            </p>
            <div className="cta-buttons">
              <Link to="/get-involved" className="btn btn-primary">Join Us</Link>
              <Link to="/contact" className="btn btn-outline">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
